// Components
import Button from './blocks/Button'
import Checkbox from './blocks/Checkbox'
import Confirm from './blocks/Confirm'
import Form from './blocks/Form'
import FormItem from './blocks/FormItem'
import Input from './blocks/Input'
import Layer from './blocks/Layer'
import List from './blocks/List'
import Loading from './blocks/Loading'
import Notice from './blocks/Notice'
import Pagination from './blocks/Pagination'
import Result from './blocks/Result'
import Steps from './blocks/Steps'
import Switch from './blocks/Switch'
import Teleport from './blocks/Teleport'
import Select from './blocks/Select'
import Option from './blocks/Select/option'

// Wrenches
import Lib from './wrenches/Lib'
import EventBus from './wrenches/EventBus'
import Validator from './wrenches/Validator'
import Tester from './wrenches/Validator/Tester'

// Css
import './theme/highlight.less'

// Package
import Package from '../package.json'

// Blocks components
export const blocks = {
		Button,
		Checkbox,
		Confirm,
		Form,
		FormItem,
		Input,
		Layer,
		List,
		Loading,
		Notice,
		Pagination,
		Result,
		Steps,
		Switch,
		Teleport,
		Select,
		Option,
}

// Blocks wrenches
const wrenches = {
		Lib,
		EventBus,
		Validator,
		Tester,
}

// Vue components install
function install(Vue) {
		const blocksKeys = Object.keys(blocks)
		blocksKeys.map((blockName) => {
				Vue.component(blocks[blockName].name, blocks[blockName])
		})
		console.log(
				`${'\n'} %c npm i blocks-view %c ${Package.version} ${'\n'}`,
				'color: #fadfa3; background: #030307; padding:5px 0;border-radius:3px 0 0 3px;',
				'color:#000000;background: #ebd29a; padding:5px 0;border-radius:0 3px 3px 0;')
}

// Vue.prototype.use
export default {install}

// Blocks UI
// export const BlocksPlus = {
//   ...blocks,
//   ...wrenches,
// }

export {
		Button,
		Checkbox,
		Confirm,
		Form,
		FormItem,
		Input,
		Layer,
		List,
		Loading,
		Notice,
		Pagination,
		Result,
		Steps,
		Switch,
		Teleport,
}

export {
		Lib,
		EventBus,
		Validator,
		Tester,
}
